import React from 'react';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';
import { Pill } from '@doer/frontend-components/pill';

interface ResolutionButtonsProps {
  resolutions: string[];
  selectedResolution: string | null;
  onResolutionChange: (resolution: string) => void;
}

export const ResolutionButtons: React.FC<ResolutionButtonsProps> = ({
  resolutions,
  selectedResolution,
  onResolutionChange
}) => {
  const { spacing } = useResponsiveSizes();

  return (
    <div
      style={{
        display: 'flex',
        gap: 8,
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginBottom: spacing.lg
      }}
    >
      {resolutions.map(res => {
        const isSelected = selectedResolution === res;
        return (
          <Pill key={res} size='XS' variant={isSelected ? 'outline' : 'ghost'} onClick={() => onResolutionChange(res)}>
            {res}
          </Pill>
        );
      })}
    </div>
  );
};
